var cov_k685896pz = function () {
  var path = "/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/assets/js/plugins/leaflet.wms.js",
      hash = "70529c248ffb589004ce86bcded7961796280e62",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/assets/js/plugins/leaflet.wms.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();